import api from '@/services/api/api';

export const useTestsCategories = (
  params = {
    filters: {},
  },
) => {
  const rubrics = useQuery(
    ['rubricsTest', params.filters],
    async () => {
      const { data } = await api.tests.getTestsCategories(
        toValue(params.filters),
      );
      return data;
    },
    {
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await rubrics.suspense();
  });

  return {
    rubrics,
  };
};
